import { useState } from "react";
import { scenes, sceneCategories } from "@/mocks/chiagua";

export default function Scenes() {
  const [cat, setCat] = useState("全部");

  const list = cat === "全部" ? scenes : scenes.filter((s) => s.category === cat);

  return (
    <section id="scenes" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-heading text-2xl text-primary-500 md:text-3xl">🎬 名场面直击</p>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">评论区高光时刻实录</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              复读现场、绝杀补刀、反向毒奶……把评论区里那些让人拍案叫绝的名场面，一张图讲给你听。
            </p>
          </div>
        </div>

        {/* 分类切换 */}
        <div className="mt-6 flex gap-2 overflow-x-auto pb-1 no-scrollbar md:flex-wrap">
          {sceneCategories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                cat === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-7 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s) => (
            <article
              key={s.id}
              className="flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[700/430] w-full overflow-hidden">
                <img
                  src={s.img}
                  alt={`评论区名场面：${s.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/60 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                  {s.category} · {s.likes}人围观
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="text-lg font-black text-foreground-950">{s.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  <i className="ri-vidicon-line" aria-hidden="true"></i> {s.scene}
                </p>
                <blockquote className="mt-3 rounded-xl bg-background-100 p-3 text-sm leading-relaxed text-foreground-800">
                  “{s.quote}”
                </blockquote>
                <p className="mt-3 flex items-start gap-2 text-xs leading-relaxed text-accent-700">
                  <i className="ri-lightbulb-flash-line mt-0.5" aria-hidden="true"></i>
                  <span>{s.highlight}</span>
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}